import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=a8e4a90a&scoped=true"
import script from "./Announcements.vue?vue&type=script&lang=js"
export * from "./Announcements.vue?vue&type=script&lang=js"
import style0 from "./Announcements.vue?vue&type=style&index=0&id=a8e4a90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e4a90a",
  null
  
)

export default component.exports